import { ChangeBoardsController } from './change-boards.controller'

function changeBoards () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/directives/change-boards/change-boards-directive.html?$$REVISION$$',
    controller: ChangeBoardsController,
    scope: {
      selectedBoard: '<'
    }
  }
}

export { changeBoards }
